import * as React from "react";

import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

import { convertUtcToLocal } from "../../helpers/CommonHelpers";
import {
  ConfiguredSourceRoot,
  SourceRootOutcomeColors,
  SourceRootOutcomeLabels,
  isUnreachable,
} from "../../models/ConfiguredSourceRoot";
import { SourceLinkOriginLabels, SourceLinkReasonLabels } from "../../models/SourceLink";
import { MigrationTypeLabels } from "../../models/Statistics/MigrationType";

const numberFormat = new Intl.NumberFormat();

/**
 * The configured roots as a table. Shared by the cycle modal and the Source Links page so the two places a root
 * can be read describe it in the same columns.
 */
const ConfiguredSourceRootsTable: React.FC<{ roots: ConfiguredSourceRoot[] }> = ({ roots }) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>Root path</TableHead>
        <TableHead>Discovery</TableHead>
        <TableHead>Origin</TableHead>
        <TableHead>Outcome</TableHead>
        <TableHead>Reason</TableHead>
        <TableHead className="text-right">Links held back</TableHead>
        <TableHead className="text-right">Records found</TableHead>
        <TableHead>Last seen</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {roots.map((root) => (
        <TableRow key={root.id}>
          <TableCell className="max-w-[24rem] break-all font-mono text-xs">{root.pathRoot}</TableCell>
          <TableCell>{MigrationTypeLabels[root.migrationType]}</TableCell>
          <TableCell>{SourceLinkOriginLabels[root.origin]}</TableCell>
          <TableCell>
            <Badge variant={SourceRootOutcomeColors[root.outcome]}>{SourceRootOutcomeLabels[root.outcome]}</Badge>
          </TableCell>
          <TableCell>{root.reason ? SourceLinkReasonLabels[root.reason] : <span>&mdash;</span>}</TableCell>
          <TableCell className="text-right tabular-nums">
            {isUnreachable(root) ? numberFormat.format(root.linksSkipped) : <span>&mdash;</span>}
          </TableCell>
          <TableCell className="text-right tabular-nums">{numberFormat.format(root.entitiesEnumerated)}</TableCell>
          <TableCell className="whitespace-nowrap">{convertUtcToLocal(root.lastSeenOn)}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default ConfiguredSourceRootsTable;
